/* eslint-disable react/prop-types */
import React from 'react';

import {
    Chart as ChartJS, ArcElement, BarElement,
    CategoryScale,
    LinearScale,
    Tooltip, Legend
} from 'chart.js';
import { Doughnut, Bar } from 'react-chartjs-2';
import { getRecoil } from 'recoil-nexus';
import { appConfigAtomState } from '../../state/reducerAtoms/app.atom';

ChartJS.register(ArcElement, Tooltip, BarElement,
    CategoryScale,
    LinearScale, Legend);


const getCenterText = (state) => {
    return {
        id: 'centerText',
        beforeDatasetsDraw(chart) {
            const metaPoint = chart.getDatasetMeta(0)?.data[0];
            if (!metaPoint) return;
            const { ctx, data } = chart;
            const text = `${data.datasets[0].totalScore || 0}%`;
            const fillStyle = `${data.datasets[0].fillStyle || `${state?.isDarkModeOn ? ('rgba(255, 255, 255, 1)') : ('rgba(0, 0, 0, 1)')}`}`;
            ctx.save();
            const { x } = metaPoint;
            const { y } = metaPoint;

            // ctx.fillRect(x - 10, y - 10, 20, 20);
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.whiteSpace = 'pre-line';
            ctx.fillStyle = fillStyle;
            ctx.font = data.datasets[0].fontStyle || 'bold 0px sans-serif';
            ctx.fillText(text, x, y - 8);
        }
    }
}

// export const data = {
//     labels: ['January', 'February', 'March', 'April'],
//     datasets: [
//         {
//             label: 'Product A',
//             data: [30, 20, 50, 40],
//             backgroundColor: 'rgba(75, 192, 192, 0.7)',
//         },
//         {
//             label: 'Product B',
//             data: [20, 30, 10, 50],
//             backgroundColor: 'rgba(255, 99, 132, 0.7)',
//         },
//     ],
// };

export function AppDoughnutChart({ data = [], options }) {
    return <Doughnut
        data={data}
        options={{
            plugins: {
                legend: {
                    display: true,
                    position: 'right',
                    labels: { color: '#FFFFFF', boxWidth: 12, font: { size: 11 } },
                },
            },
            cutout: '60%',
            ...options,
        }}
    />;
}

export function AppBarChart({ data = [], options }) {
    const appState = getRecoil(appConfigAtomState);



    return <Bar
        data={data}
        plugins={[getCenterText(appState)]}
        options={{
            appState,
            plugins: {
                legend: {
                    display: false
                },
            },
            scales: {
                x: {
                    stacked: true,
                },
                y: {
                    stacked: true,
                },
            },
            title: {
                display: false,
                text: ""
            },
            ...options
            // cutout: '70%'
        }} />;
}
